import { appConfig } from '../../../../config'
import { CaseResponse } from './types'

export const getUserCases = async ({ accessToken }: { accessToken: string }): Promise<CaseResponse[]> => {
  const res = await fetch(`${appConfig.serverRootUrl}/api/private/case`, {
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  })
  if (!res.ok) {
    throw new Error(`Failed to fetch cases: ${res.status}`)
  }
  return res.json()
}
